import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { Trans } from '@lingui/react/macro'

import { useGetCustomer } from '@jotta/grpc-connect-client/customer'
import SvgLockKey from '@jotta/ui/SvgLockKey'

function ReadLock() {
  return (
    <div className="flex size-full items-center justify-around">
      <div className="flex flex-col items-center gap-4 p-24">
        <SvgLockKey height={100} />
        <header className="label-lg">
          <Trans>Account Locked</Trans>
        </header>
        <div>
          <Trans>
            Your account is locked, and your content is currently unavailable.
            Please review{' '}
            <Link className="link" to="/web/billing">
              your subscription
            </Link>{' '}
            to restore access.
          </Trans>
        </div>
      </div>
    </div>
  )
}

export function ReadLockBlock({ children }: { children: ReactNode }) {
  const { data } = useGetCustomer()
  if (data?.accountLock?.isReadLocked) {
    return <ReadLock />
  } else {
    return children
  }
}
